import { useMorphingSearchChips } from "./morphing-search-chips/use-morphing-search-chips";
import { MorphingSearchChipsView } from "./morphing-search-chips/view";
import type { MorphingSearchChipsProps } from "./morphing-search-chips/model";
export type { MorphingSearchChipsProps } from "./morphing-search-chips/model";
export function MorphingSearchChips(props: MorphingSearchChipsProps) {
return <MorphingSearchChipsView {...useMorphingSearchChips(props)} />;
}
